module.exports = __webpack_public_path__ + "media/img/frontend_application/review-blank-f7618379f6497f8e6347e634cd76ac2b.png";